export default {
  MEDIA_UPLOAD_API: {
    URL_BASE: {
      GLOBAL: process.env.MEDIA_UPLOAD_API.URL_BASE.GLOBAL,
    },
  },
  NO_IMAGE_URL: {
    UID: process.env.ATCOSME_USER_URL + 'img/common/noimage.png',
    BID: process.env.NO_IMAGE_URL,
  },
  CDN_HOST           : process.env.CDN_HOST,
  SMALL_LIGHT_HOST   : process.env.SMALL_LIGHT_HOST,
  SMALL_LIGHT_OPTIONS: {
    da: 's',
    ds: 'n',
    cw: 200,
    ch: 200,
    dw: 200,
    dh: 200,
    cc: 'FFFFFF',
  },
};
